import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/codiepie': {
    width: 472,
    height: 512,
    paths: [
      {
        d: 'M422.5 202.9C453.2 202.9 456 256 422.2 256H411.4V300.3H384.8V202.9H422.5zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8C345.4 8 420.8 61.7 466.2 146.4L280.2 255.2 472 352.6zM433.5 365.1L373.2 334.4C346.1 378.7 302.8 405.8 250.8 405.8 168.3 405.8 101.6 339.1 101.6 256.9 101.6 174.4 168.3 107.7 250.8 107.7 299.2 107.7 339.7 131.2 367.7 171.1L427.2 136.5C386.5 73.9 322.5 36.5 248 36.5 126.8 36.5 28.5 134.8 28.5 256S126.8 475.5 248 475.5C326.6 475.5 394.5 433.4 433.5 365.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/codiepie.js
// module id = MPqE
// module chunks = 144